import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { X, Filter } from "lucide-react";
import { Button } from "@/components/ui/button";
export function ActiveFilterChips({ selectedFilters, filterGroups, onRemoveFilter, onClearAll, }) {
    // Get all active filters with their labels
    const activeFilters = [];
    Object.entries(selectedFilters).forEach(([groupId, optionIds]) => {
        const group = filterGroups.find((g) => g.id === groupId);
        if (!group)
            return;
        optionIds.forEach((optionId) => {
            const option = group.options.find((o) => o.id === optionId);
            if (option) {
                activeFilters.push({
                    groupId,
                    groupLabel: group.label,
                    optionId,
                    optionLabel: option.label || optionId,
                });
            }
        });
    });
    if (activeFilters.length === 0)
        return null;
    return (_jsxs("div", { className: "flex flex-wrap items-center gap-2 mb-4", children: [_jsxs("div", { className: "flex items-center gap-1.5 text-[#4a4a4a]/60 text-sm", children: [_jsx(Filter, { className: "w-3.5 h-3.5" }), _jsx("span", { children: activeFilters.length })] }), activeFilters.map((filter) => (_jsxs("button", { onClick: () => onRemoveFilter(filter.groupId, filter.optionId), className: "inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#c85a3f]/10 border border-[#c85a3f]/20 text-[#c85a3f] hover:bg-[#c85a3f]/20 transition-colors text-sm", children: [_jsxs("span", { children: [filter.groupLabel, ": ", filter.optionLabel] }), _jsx(X, { className: "w-3 h-3" })] }, `${filter.groupId}-${filter.optionId}`))), _jsx(Button, { variant: "ghost", size: "sm", onClick: onClearAll, className: "text-[#4a4a4a]/60 hover:text-[#c85a3f] hover:bg-[#c85a3f]/10 h-auto py-0.5 px-2 text-sm", children: "Clear all" })] }));
}
